import cookie from 'react-cookies';

export const PROVIDER_ID_COOKIE = 'providerId';

const getProviderId = (): string => {
    return cookie.load(PROVIDER_ID_COOKIE) || '';
};

export default getProviderId;
